"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailsMore = exports.detailsBase = void 0;
const article_1 = __importDefault(require("./article"));
const list_1 = require("./list");
/**
 * Create the Markdown from the DetailsBaseType object.
 * @param source The pair of name and detail.
 * @param level The heading level.
 *
 * If omitted, its default value is `2`.
 */
const detailsBase = ({ addition = '', level = 2, src, }) => article_1.default({ body: `${src.detail} ${addition}`, head: src.name, level });
exports.detailsBase = detailsBase;
/**
 * Create the Markdown from the DetailsType object.
 * @param source The name, detail and more descriptions.
 */
const detailsMore = ({ level = 3, src, ...rest }) => list_1.line(exports.detailsBase({ level, src, ...rest }), list_1.list(...src.more));
exports.detailsMore = detailsMore;
//# sourceMappingURL=details.js.map